import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { VideoThumbnailComponent } from '../video-thumbnail/video-thumbnail.component';
import { VideoSearchResult } from '../../model/video-search-result.model';
import { Router } from '@angular/router';
import { VideoMetadataComponent } from "../video-metadata/video-metadata.component";

@Component({
  selector: 'app-video-card',
  templateUrl: './video-card.component.html',
  styleUrls: ['./video-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    VideoThumbnailComponent,
    VideoMetadataComponent
]
})
export class VideoCardComponent implements OnInit {

  @Input() video: VideoSearchResult = null;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  isLoading(): boolean {
    return !this.video;
  }

  onVideoClick(video: VideoSearchResult) {
    const videoId = video.id;

    this.router.navigate(['/watch', videoId],
      {
        state: { video },
      }
    );
  }

  getFormatedVideoDuration(): string {

    let videoDurationInSeconds = this.video?.duration_in_seconds;
    let seconds = 0;
    let minutes = 0;
    let hours = 0;
    let durationOutputString = '';


    if (!videoDurationInSeconds) {
      return '0:00';
    }

    videoDurationInSeconds = Math.floor(videoDurationInSeconds);

    // Convert the duration from seconds to a human-readable format
    minutes = Math.floor(videoDurationInSeconds / 60);
    seconds = videoDurationInSeconds % 60;
    hours = Math.floor(minutes / 60);
    minutes = minutes % 60;

    if (hours > 0) {
      durationOutputString += hours + ':';
    }

    if (minutes < 10) {
      durationOutputString += '0';
    }

    durationOutputString += minutes + ':';

    if (seconds < 10) {
      durationOutputString += '0';
    }

    durationOutputString += seconds;

    return durationOutputString;
  }

}
